/**
 * This file is part of SesaXXX.
 *   Copyright 2014-2015, Association Sésamath
 *
 * SesaXXX is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License version 3
 * as published by the Free Software Foundation.
 *
 * SesaXXX is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with SesaReactComponent (LICENCE.txt).
 * @see http://www.gnu.org/licenses/agpl.txt
 *
 *
 * Ce fichier fait partie de SesaReactComponent, créée par l'association Sésamath.
 *
 * SesaXXX est un logiciel libre ; vous pouvez le redistribuer ou le modifier suivant
 * les termes de la GNU Affero General Public License version 3 telle que publiée par la
 * Free Software Foundation.
 * SesaXXX est distribué dans l'espoir qu'il sera utile, mais SANS AUCUNE GARANTIE,
 * sans même la garantie tacite de QUALITÉ MARCHANDE ou d'ADÉQUATION à UN BUT PARTICULIER.
 * Consultez la GNU Affero General Public License pour plus de détails.
 * Vous devez avoir reçu une copie de la GNU General Public License en même temps que SesaQcm
 * (cf LICENCE.txt et http://vvlibri.org/fr/Analyse/gnu-affero-general-public-license-v3-analyse
 * pour une explication en français)
 */
/* global Blob */
'use strict'

/**
 * Log dans console.error si error fourni
 * @param {Error} [error]
 */
function logIfError (error) {
  if (error) console.error(error)
}

/**
 * Transforme une chaine en fichier téléchargeable
 * @param {Object} content Contenu du fichier
 * @param {string} filename Nom du fichier à générer
 */
function download (content, filename) {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8;' })

  const element = document.createElement('a')
  element.style.display = 'none'
  element.setAttribute('target', '_blank')
  element.setAttribute('download', filename)

  document.body.appendChild(element)
  element.setAttribute('href', URL.createObjectURL(blob))
  element.click()
  document.body.removeChild(element)
}

module.exports = {
  logIfError,
  download
}
